import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  fullWidth?: boolean;
  onClick?: () => void;
};
export function Button({
  children,
  href,
  className = '',
  fullWidth,
  onClick
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} onClick={onClick} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex items-center justify-center rounded-xl bg-primary px-7 py-4 text-center text-base font-extrabold uppercase tracking-wide text-white shadow-[0_14px_30px_rgba(219,39,119,.32)] transition-colors duration-150 ease-out hover:bg-primary-dark focus:outline-none focus:ring-4 focus:ring-primary/30 ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-238" data-mp="zuu59fsq3l3g">
      {children}
    </motion.a>;
}